module.exports = __webpack_public_path__ + "static/media/strongher11_preview.43489212.jpg";